
import { ref, onMounted, onUnmounted } from 'vue';

export function useAnimatedProgressProvider({
  valueStart = 0,
  valueEnd,
  duration = 1000,
  easingFunction,
  repeat = false,
}) {
  const value = ref(valueStart);
  let animationFrame;
  let interval;
  let startTime;
  let forward = true;

  const animate = (timestamp) => {
    if (!startTime) startTime = timestamp;
    const elapsed = timestamp - startTime;
    const progress = Math.min(elapsed / duration, 1);
    const eased = easingFunction(progress);

    value.value = forward
      ? valueStart + (valueEnd - valueStart) * eased
      : valueEnd - (valueEnd - valueStart) * eased;

    if (progress < 1) {
      animationFrame = requestAnimationFrame(animate);
    }
  };

  const startAnimation = () => {
    startTime = null;
    animationFrame = requestAnimationFrame(animate);
  };

  onMounted(() => {
    if (repeat) {
      startAnimation();
      interval = setInterval(() => {
        forward = !forward;
        startTime = null;
        animationFrame = requestAnimationFrame(animate);
      }, duration);
    } else {
      startAnimation();
    }
  });

  onUnmounted(() => {
    cancelAnimationFrame(animationFrame);
    clearInterval(interval);
  });

  return { value };
}
